import styled from 'styled-components';
import Link from 'next/link';
import Imgix from 'shared/components/imgix';

export const LockScreenContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100dvh;
`;

export const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  padding: 24px;
`;

export const Logo = styled(Imgix)`
  display: block;
`;

export const ButtonContainer = styled.div`
  padding: 48px 24px;
  width: 100%;
`;

export const KioskIdentityLabel = styled.div`
  background-color: var(--dcm-kiosk-identity-bg, rgba(0, 0, 0, 0.65));
  border-radius: var(--dcm-kiosk-identity-radius, 999px);
  color: var(--dcm-kiosk-identity-color, #fff);
  font-size: var(--dcm-kiosk-identity-font-size, 16px);
  font-weight: var(--dcm-kiosk-identity-font-weight, 600);
  padding: var(--dcm-kiosk-identity-padding, 8px 16px);
  position: fixed;
  right: var(--dcm-kiosk-identity-right, 16px);
  top: var(--dcm-kiosk-identity-top, 16px);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
`;

/* Invisible stand-in shown in the chip's place once hidden, so the staff gesture still has
   something to tap. No background/border/cursor so it stays undetectable. */
export const KioskIdentityTapRegion = styled.div`
  position: fixed;
  right: var(--dcm-kiosk-identity-right, 16px);
  top: var(--dcm-kiosk-identity-top, 16px);
  width: var(--dcm-kiosk-identity-tap-region-size, 64px);
  height: var(--dcm-kiosk-identity-tap-region-size, 64px);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
`;

export const StartShoppingButton = styled(Link)`
  appearance: none;
  background-color: var(--dct--customized-colors-buttonsLinks);
  border: none;
  border-radius: var(--dct--customized-radius-buttons);
  color: ${({ theme }) => theme.colors.white};
  display: block;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  margin: 0 auto;
  max-width: 600px;
  outline: none;
  padding: 26px 12px;
  text-align: center;
  text-decoration: none;
  text-transform: var(--dct--customized-textTransforms-buttons);
  white-space: nowrap;
  width: 100%;
`;
